module.exports = "\n#if defined(USE_VERTEX_ID) || defined(USE_FRAGMENT_UBO)\nvId = id;\n#endif\n";